import { Box, Typography } from '@mui/material';
import GeneralStep1 from 'assets/GeneralStep1.webp';
import GeneralStep2 from 'assets/GeneralStep2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function QaDescription() {
  return (
    <Box>
      <Typography variant='h6'>"Q&A" Chunking Method Description</Typography>
      <Typography marginTop={2}>This chunk method supports {allowedFilesMap.qa.join(', ')} formats.</Typography>

      <ul>
        <li>
          If the file is in Excel format, it should consist of two columns without headers: one for questions and the
          other for answers, with the question column preceding the answer column. Multiple sheets are acceptable as
          long as the columns are correctly structured.
        </li>
        <li>
          If the file is in CSV/TXT format, it must be UTF-8 encoded with TAB used as the delimiter to separate
          questions and answers.
        </li>
      </ul>
      <Typography>
        Lines of texts that fail to follow the above rules will be ignored, and each Q&A pair will be considered a
        distinct chunk.
      </Typography>
      <Typography fontWeight='500' marginTop={3}>
        "Q&A" Examples
      </Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={GeneralStep1} alt='GeneralStep1' width={320} />
        <img src={GeneralStep2} alt='GeneralStep2' width={320} />
      </Box>
    </Box>
  );
}
